export default "__VITE_ASSET__DmAmEFZF__"